export const SPIRIT_KEYWORDS = [
  "whisky",
  "gin",
  "vodka",
  "brandy",
  "rum",
  "tequila",
  "cognac",
  "mezcal",
  "agave",
  "spirits",
  "liqueur",
  "cocktail",
];

export const hasSpiritsInPath = (pathname?: string): boolean => {
  return SPIRIT_KEYWORDS.some((keyword) =>
    pathname?.toLowerCase().includes(keyword.toLowerCase())
  );
};
